import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ProjeNotuEditComponent } from './proje-notu-edit.component';
import { ProjeNotuKartComponent } from './proje-notu-kart.component';

@DinamikBilesen({
  id: 'proje-notu',
  baslik: 'Proje Notu',
  aciklama: 'Proje notu ekle',
  ikon: 'file-text',
  kategori: 'proje',
})
class ProjeNotu {
  paylas_kutusu = ProjeNotuEditComponent;
  paylasilmis_kart = ProjeNotuKartComponent;
}
